import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useRajLanding } from "./useRajLanding.ts";
import "./RajLandingPage.css";
import rajLogo from "./assets/raj-logo.png";
import menuIcon from "./assets/menu.svg";
import arrowLeft from "./assets/arrow-left.svg";
import telephone from "./assets/telephone.svg";
import zoomIn from "./assets/zoom-in.svg";
import closeIcon from "./assets/x-lg.svg";
import designIcon from "./assets/pencil-square.svg";
import productionIcon from "./assets/gear.svg";
import inventoryIcon from "./assets/boxes.svg";
import portalIcon from "./assets/shop.svg";
import familyHero from "./assets/dashboard-hero.webp";
import portalArt from "./assets/portal-concept.webp";
import mailIcon from "./assets/envelope-paper.svg";
import driveIcon from "./assets/folder2-open.svg";
import calendarIcon from "./assets/calendar3.svg";
import crmIcon from "./assets/kanban.svg";
import crmScreen from "./assets/crm-screen.webp";
import RajJourneyMotion from "./RajJourneyMotion.tsx";
import productionSpools from "./assets/production-spools.webp";

import designScreen from "./assets/design-screen.webp";
import productionScreen from "./assets/production-screen.webp";
import inventoryScreen from "./assets/inventory-screen.webp";
import portalScreen from "./assets/portal-screen.webp";
import correspondenceScreen from "./assets/correspondence-screen.webp";
import driveScreen from "./assets/drive-screen.webp";
import calendarScreen from "./assets/calendar-screen.webp";

const products = [
  {
    id: "design", title: "اتوماسیون طراحی", label: "طراحی",
    description: "طرح درست، پیش از شروع بافت", art: "/raj/assets/design-proof.webp",
    icon: designIcon, screen: designScreen, screenTitle: "تصویر روشنی از کار تیم طراحی",
    detail: "کارهای در جریان و عملکرد تیم را کنار هم ببینید؛ پیش از آن‌که گره‌ها به تأخیر تبدیل شوند.",
  },
  {
    id: "production", title: "مدیریت تولید", label: "تولید",
    description: "بدانید هر کار کجای مسیر است", art: productionSpools,
    icon: productionIcon, screen: productionScreen, screenTitle: "از برنامه تا پیشرفت تولید",
    detail: "بدانید چه کاری در انتظار است و چه کاری پیش می‌رود؛ اولویت‌ها را با دید روشن‌تری تعیین کنید.",
  },
  {
    id: "inventory", title: "انبارداری", label: "انبار",
    description: "بدانید چه چیزی آماده است", art: "/raj/assets/inventory-rugs.webp",
    icon: inventoryIcon, screen: inventoryScreen, screenTitle: "با اطمینان از موجودی تصمیم بگیرید",
    detail: "پیش از وعده به مشتری، تصویر روشنی از موجودی محصول داشته باشید.",
  },
  {
    id: "portal", title: "پرتال نمایندگان", label: "نمایندگان",
    description: "سفارش‌گیری، بدون رفت‌وبرگشت", art: portalArt,
    icon: portalIcon, screen: portalScreen, screenTitle: "روند سفارش‌ها را گم نکنید",
    detail: "روند فروش و سفارش‌ها را یک‌جا ببینید و تغییرات کسب‌وکار را زودتر تشخیص دهید.",
  },
];

const collaborationTools = [
  { id: "crm", title: "مدیریت ارتباط با مشتری", description: "هیچ فرصتی از پیگیری جا نماند", icon: crmIcon,
    screen: crmScreen, screenTitle: "هر مذاکره، یک قدم نزدیک‌تر به فروش", label: "CRM",
    detail: "فرصت‌ها، مرحلهٔ مذاکره و اقدام بعدی را روی یک برد ببینید؛ پیگیری‌ها به حافظهٔ افراد وابسته نماند." },
  { id: "correspondence", title: "مکاتبات اداری", description: "نامه‌ای بی‌پاسخ نماند", icon: mailIcon,
    screen: correspondenceScreen, screenTitle: "هر مکاتبه، یک مسیر روشن", label: "مکاتبات اداری",
    detail: "از دریافت تا اقدام، مکاتبات را دنبال کنید و کارهای نیازمند رسیدگی را ببینید." },
  { id: "drive", title: "مدیریت فایل", description: "فایل درست، در دسترس تیم", icon: driveIcon,
    screen: driveScreen, screenTitle: "کمتر دنبال فایل‌ها بگردید", label: "مدیریت فایل",
    detail: "فایل‌های کاری و اشتراک‌های تیم را یک‌جا داشته باشید؛ بدون پراکندگی در پیام‌ها." },
  { id: "calendar", title: "تقویم کاری", description: "قرار و پیگیری از قلم نیفتد", icon: calendarIcon,
    screen: calendarScreen, screenTitle: "قرار بعدی، از همین حالا روشن است", label: "تقویم کاری",
    detail: "از بازبینی نمونه‌بافت تا پیگیری نماینده؛ زمان، یادآور و جزئیات هر قرار کنار هم‌اند." },
];

const previews = [...products, ...collaborationTools];

export default function RajLandingPage() {
  const menuRef = useRajLanding();
  const [active, setActive] = useState(1);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const tabsRef = useRef<HTMLDivElement>(null);
  const product = previews[active];

  function moveTab(event: React.KeyboardEvent<HTMLButtonElement>) {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    let next = active;
    if (event.key === "ArrowLeft") next = (active + 1) % previews.length;
    else if (event.key === "ArrowRight") next = (active + previews.length - 1) % previews.length;
    else if (event.key === "Home") next = 0;
    else if (event.key === "End") next = previews.length - 1;
    else return;
    event.preventDefault();
    setActive(next);
    tabsRef.current?.querySelectorAll<HTMLButtonElement>("button")[next]?.focus();
  }

  return (
    <div
      className="raj-landing"
      lang="fa"
      dir="rtl"
    >
      <Link
        className="raj-landing__skip-link"
        to="#main"
      >
        رفتن به محتوای اصلی
      </Link>
      <header className="raj-landing__site-header raj-landing__wrap">
        <Link
          className="raj-landing__brand"
          to="#main"
          aria-label="رج؛ ابتدای صفحه"
        >
          <img
            src={rajLogo}
            alt="رج"
            width="54"
            height="60"
          />
          <span className="raj-landing__brand-caption">
            نرم‌افزارهای<br />صنعت فرش
          </span>
        </Link>
        <nav
          className="raj-landing__desktop-nav"
          aria-label="ناوبری اصلی رج"
        >
          <Link to="#solutions">راهکارهای رج</Link>
          <Link to="#showcase">محیط نرم‌افزار</Link>
          <Link to="#about">آشنایی با رج</Link>
        </nav>
        <div className="raj-landing__header-actions">
          <a
            className="raj-landing__header-demo"
            href="tel:+982191099159"
            aria-label="تماس با رج: ۰۲۱۹۱۰۹۹۱۵۹"
          >
            <img
              src={telephone}
              alt=""
              width="17"
              height="17"
            />
            <bdi dir="ltr">۰۲۱ ۹۱۰۹۹۱۵۹</bdi>
          </a>
          <details
            className="raj-landing__site-menu"
            ref={menuRef}
          >
            <summary aria-label="منوی صفحه">
              <img
                src={menuIcon}
                alt=""
                width="26"
                height="26"
              />
            </summary>
            <nav aria-label="ناوبری صفحه رج">
              <Link to="#solutions">راهکارهای رج</Link>
              <Link to="#showcase">محیط نرم‌افزار</Link>
              <Link to="#workflow">مسیر یک سفارش</Link>
              <Link to="#about">درباره رج و تماس</Link>
            </nav>
          </details>
        </div>
      </header>
      <main
        id="main"
        tabIndex={-1}
      >
        <section
          className="raj-landing__hero"
          aria-labelledby="hero-title"
        >
          <div className="raj-landing__hero-copy raj-landing__wrap">
            <p className="raj-landing__eyebrow">نرم‌افزارهای تخصصی صنعت فرش</p>
            <h1 id="hero-title">
              با رج، هماهنگ‌تر
              <br />
              <em>مدیریت کنید.</em>
            </h1>
            <p className="raj-landing__hero-description">
              از سفارش تا محصول آماده؛ راهکارهایی برای دید روشن‌تر،
              تصمیم دقیق‌تر و همکاری بهتر.
            </p>
            <div className="raj-landing__hero-actions">
              <a
                className="raj-landing__button"
                href="tel:+982191099159"
              >
                درخواست دمو
              </a>
              <Link
                className="raj-landing__button raj-landing__button-outline"
                to="#solutions"
              >
                دیدن راهکارها
              </Link>
            </div>
          </div>
          <div className="raj-landing__hero-art">
            <img
              src={familyHero}
              alt="لپ‌تاپ رج در کنار نخ و فرش"
              width="1400"
              height="933"
            />
            <img
              className="raj-landing__laptop-screen"
              src={productionScreen}
              alt="نمای واقعی داشبورد تولید رج روی نمایشگر لپ‌تاپ"
              width="1118"
              height="611"
            />
          </div>
        </section>
        <section
          className="raj-landing__solutions"
          id="solutions"
          aria-labelledby="solutions-title"
          tabIndex={-1}
        >
          <div className="raj-landing__wrap">
            <div className="raj-landing__section-heading">
              <h2 id="solutions-title">کارها کمتر پراکنده، تصمیم‌ها روشن‌تر.</h2>
            </div>
            <div className="raj-landing__product-grid">
              {products.map(function (item, index) {
                return (
                  <Link
                    className={`raj-landing__product raj-landing__product--${item.id}`}
                    to="#showcase"
                    key={item.id}
                    onClick={function () { setActive(index); }}
                    aria-label={`مشاهده ${item.title}`}
                  >
                    <img
                      className="raj-landing__product-art"
                      src={item.art}
                      alt=""
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="raj-landing__product-copy">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                    <span className="raj-landing__product-arrow">
                      <img
                        src={arrowLeft}
                        alt=""
                        width="18"
                        height="18"
                      />
                    </span>
                  </Link>
                );
              })}
            </div>
            <div className="raj-landing__collaboration-tools">
              {collaborationTools.map(function (item, index) {
                return (
                  <Link
                    className="raj-landing__collaboration-tool"
                    to="#showcase"
                    key={item.id}
                    onClick={function () { setActive(products.length + index); }}
                  >
                    <img
                      src={item.icon}
                      alt=""
                      width="24"
                      height="24"
                    />
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                    <img
                      src={arrowLeft}
                      alt=""
                      width="18"
                      height="18"
                    />
                  </Link>
                );
              })}
            </div>
          </div>
        </section>
        <section
          className="raj-landing__showcase raj-landing__wrap"
          id="showcase"
          aria-labelledby="showcase-title"
          tabIndex={-1}
        >
          <div className="raj-landing__section-heading">
            <p className="raj-landing__eyebrow">از نزدیک با رج</p>
            <h2 id="showcase-title">ببینید کدام گره از کارتان باز می‌شود.</h2>
            <p>از پیگیری مشتری تا هماهنگی تیم؛ رج را در موقعیت‌های کاری ببینید.</p>
          </div>
          <div
            className="raj-landing__tabs"
            role="tablist"
            aria-label="تصاویر محیط نرم‌افزار"
            ref={tabsRef}
          >
            {previews.map(function (item, index) {
              return (
                <button
                  type="button"
                  role="tab"
                  id={`raj-tab-${item.id}`}
                  aria-controls={`raj-panel-${item.id}`}
                  aria-selected={active === index}
                  tabIndex={active === index ? 0 : -1}
                  key={item.id}
                  onClick={function () { setActive(index); }}
                  onKeyDown={moveTab}
                >
                  {item.id === "portal" ? "فروش" : item.label}
                </button>
              );
            })}
          </div>
          {previews.map(function (item, index) {
            return (
              <div
                role="tabpanel"
                id={`raj-panel-${item.id}`}
                aria-labelledby={`raj-tab-${item.id}`}
                hidden={active !== index}
                key={item.id}
                tabIndex={0}
                className="raj-landing__preview-panel"
              >
                <figure className="raj-landing__screen-figure">
                  <button
                    type="button"
                    className="raj-landing__screen-button"
                    onClick={function () { dialogRef.current?.showModal(); }}
                    aria-label={`بزرگ‌نمایی تصویر ${item.screenTitle}`}
                  >
                    <img
                      className="raj-landing__screen"
                      src={item.screen}
                      alt={`تصویر واقعی ${item.screenTitle} در نرم‌افزار رج`}
                      loading="lazy"
                      decoding="async"
                    />
                    <span className="raj-landing__zoom-label">
                      <img
                        src={zoomIn}
                        alt=""
                        width="17"
                        height="17"
                      />
                      نمایش بزرگ‌تر
                    </span>
                  </button>
                  <figcaption>
                    <strong>{item.screenTitle}</strong>
                    <span>{item.detail}</span>
                  </figcaption>
                </figure>
              </div>
            );
          })}
        </section>
        <section
          className="raj-landing__workflow raj-landing__wrap"
          id="workflow"
          aria-labelledby="workflow-title"
          tabIndex={-1}
        >
          <div className="raj-landing__section-heading">
            <p className="raj-landing__eyebrow">از انتخاب تا محصول آماده</p>
            <h2 id="workflow-title">داستان یک سفارش، تا تبدیل‌شدن به فرش.</h2>
            <p>سفارش، طراحی، تولید و انبار؛ چهار بخش از یک تصویر بزرگ‌تر.</p>
          </div>
          <RajJourneyMotion />
        </section>
        <section
          className="raj-landing__contact"
          id="about"
          aria-labelledby="contact-title"
          tabIndex={-1}
        >
          <div className="raj-landing__wrap">
            <h2 id="contact-title">رج را برای کارخانه خودتان ببینید.</h2>
            <p>با یک نمایش اختصاصی، از نزدیک با امکانات آشنا شوید.</p>
            <a
              className="raj-landing__button raj-landing__button-light"
              href="tel:+982191099159"
            >
              درخواست دمو
            </a>
            <a
              className="raj-landing__contact-phone"
              href="tel:+982191099159"
              aria-label="تماس با رج: ۰۲۱۹۱۰۹۹۱۵۹"
            >
              <bdi dir="ltr">۰۲۱ ۹۱۰۹۹۱۵۹</bdi>
              <img
                src={telephone}
                alt=""
                width="20"
                height="20"
              />
            </a>
            <p className="raj-landing__contact-note">پاسخ‌گوی سؤال‌های شما هستیم.</p>
            <footer className="raj-landing__site-footer">
              <Link
                className="raj-landing__footer-brand"
                to="#main"
                aria-label="رج؛ ابتدای صفحه"
              >
                <img
                  src={rajLogo}
                  alt="رج"
                  width="50"
                  height="56"
                  loading="lazy"
                />
                <span>نرم‌افزارهای تخصصی<br />صنعت فرش</span>
              </Link>
              <nav aria-label="پیوندهای پایانی">
                <Link to="#solutions">راهکارها</Link>
                <Link to="#showcase">محیط نرم‌افزار</Link>
                <a href="tel:+982191099159">تماس با ما</a>
              </nav>
            </footer>
          </div>
        </section>
      </main>
      <dialog
        className="raj-landing__image-dialog"
        ref={dialogRef}
        aria-labelledby="raj-image-title"
        onClick={function (event) {
          if (event.target === event.currentTarget) dialogRef.current?.close();
        }}
      >
        <div className="raj-landing__dialog-header">
          <h2 id="raj-image-title">{product.screenTitle}</h2>
          <button
            type="button"
            aria-label="بستن تصویر"
            onClick={function () { dialogRef.current?.close(); }}
          >
            <img
              src={closeIcon}
              alt=""
              width="20"
              height="20"
            />
          </button>
        </div>
        <div className="raj-landing__dialog-scroll">
          <img
            src={product.screen}
            alt={`تصویر واقعی ${product.screenTitle}`}
          />
        </div>
        <p>برای دیدن جزئیات روی موبایل، تصویر را به طرفین حرکت دهید.</p>
      </dialog>
    </div>
  );
}
